import { AdapterRegistry } from 'app/model/adapters/adapter-registry';
import { Metamodel } from 'app/model/base/model';

import { salesforceSinkAdapts } from './salesforce.sink.adapter';
import { SalesforceV2SinkAdapter } from './salesforcev2.sink.adapter';
import { IModel, SalesforceServiceCloudV2Sink } from 'shell-models-lib';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(SalesforceServiceCloudV2Sink),
    asynchronous: true,
    adapts: salesforceSinkAdapts
})
export class SalesforceServiceCloudV2SinkAdapter extends SalesforceV2SinkAdapter {
    protected override model(): IModel {
        return SalesforceServiceCloudV2Sink.MODEL;
    }
}
